import SimpleTax from "assets/images/logo_solo.png";

export const Simpletax = {
  logo: SimpleTax,
  width: "193px",
};
